"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>Assets_VoteDown
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const VoteDown = ({ isActive = false })=>{
    if (isActive) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("svg", {
        width: "17",
        height: "15",
        viewBox: "0 0 17 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.7998 0.102223H13.7525V9.04089H16.7998V0.102223ZM0.0398049 8.296C0.0398049 9.11538 0.725442 9.78578 1.56344 9.78578H6.3629L5.60108 13.2123V13.4357C5.60108 13.7337 5.75344 14.0316 5.9058 14.2551L6.7438 15L11.7718 10.0837C12.0765 9.86027 12.2289 9.48782 12.2289 9.04089V1.592C12.2289 0.772624 11.5433 0.102223 10.7053 0.102223H3.8489C3.23944 0.102223 2.70617 0.474668 2.47762 0.99609L0.192168 6.2848C0.0398039 6.43378 0.0398049 6.58276 0.0398049 6.80622V8.296Z",
            fill: "#4F6F8F"
        })
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
            d: "M1.24 10.24C0.92 10.24 0.64 10.12 0.4 9.88C0.16 9.64 0.04 9.36 0.04 9.04V7.40322C0.04 7.30774 0.03 7.21 0.01 7.11C-0.01 7.01 0 6.91333 0.04 6.82L2.56 1.02C2.67837 0.736667 2.87567 0.495833 3.1519 0.2975C3.42811 0.0991667 3.71748 0 4.02 0H12.9V10.24L8.4 15C8.21867 15.1867 8.00409 15.2967 7.75626 15.33C7.50845 15.3633 7.26969 15.3133 7.04 15.18C6.81333 15.0467 6.64333 14.8633 6.53 14.63C6.41667 14.3967 6.38867 14.1533 6.446 13.9L7.22 10.24H1.24ZM11.7 9.74V1.2H3.76L1.24 7.18V9.04H8.7L7.64 14.02L11.7 9.74ZM15.56 0C15.89 0 16.1725 0.1175 16.4075 0.3525C16.6425 0.5875 16.76 0.87 16.76 1.2V9.04C16.76 9.37 16.6425 9.6525 16.4075 9.8875C16.1725 10.1225 15.89 10.24 15.56 10.24H12.9V9.04H15.56V1.2H12.9V0H15.56Z",
            fill: "#4F6F8F"
        })
    });
};
const Assets_VoteDown = VoteDown;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
